import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Table, Modal } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";

const Payment = ({ user , setCartItems}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cartItems, formData } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const totalCost = cartItems.reduce((total, item) => {
  const price = parseFloat(item.price.replace(/[^0-9.-]+/g, ""));
  return total + (isNaN(price) ? 0 : price * (item.quantity || 1));
  }, 0);

  const handleDeleteFromCart = async (itemId) => {
  try {
    const response = await fetch(`https://backend-matihaat.onrender.com/cart/${user.userId}/${itemId}`, {
      method: 'DELETE',
    });

    const data = await response.json();
    if (data.success) {
      setCartItems(data.cart); // Update state after deletion
    }
  } catch (error) {
    console.error("Error deleting item:", error);
  }
};


  const createOrder = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://backend-matihaat.onrender.com/api/payment/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: totalCost }),
      });

      const data = await response.json();
      if (data.success && data.order && data.order.id) {
        setLoading(false);
        initializeRazorpay(data.order.id);
      } else {
        console.error("Failed to create order:", data.message);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error in order creation:", error);
      setLoading(false);
    }
  };

  const initializeRazorpay = (order_id) => {
    const options = {
      key: 'rzp_live_wDb7Y2XtYhcs7U',
      amount: totalCost * 100,
      currency: 'INR',
      name: 'Maihaat',
      description: 'Order Payment',
      order_id,
      handler: async (response) => {
        const verifyPayload = {
        razorpay_order_id: order_id,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
        userId: user.userId,
        user_name: `${formData.firstName} ${formData.lastName}`,
        user_email: formData.email,
        user_phone: formData.phone,
        billing_address: `${formData.streetAddress}${formData.apartment ? `, ${formData.apartment}` : ''}`,
        billing_city: formData.town,
        billing_pincode: formData.postcode,
        billing_state: formData.state,
        cartItems: cartItems.map(item => ({
          item_id: item._id,
          name: item.name,
          price: item.price,
          quantity: item.quantity || 1,
        })),
        totalPrice: totalCost,
      };

        try {
          const verifyRes = await fetch('https://backend-matihaat.onrender.com/api/payment/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(verifyPayload),
          });
          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            // Show order details modal
            setOrderDetails(verifyData.order);
            setShowModal(true);
            // Clear the cart via prop function or context
            // if (clearCart) clearCart();
          } else {
            alert("❌ Payment verification failed");
          }
        } catch (err) {
          console.error("Verification error:", err);
        }
      },
      prefill: {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        contact: formData.phone,
      },
      theme: { color: '#F37254' },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  useEffect(() => {
    const loadRazorpayScript = () => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => console.log('Razorpay script loaded');
      script.onerror = () => console.error('Failed to load Razorpay script');
      document.body.appendChild(script);
    };

    if (cartItems?.length && formData?.email) {
      loadRazorpayScript();
    }
  }, [formData, cartItems]);

  const handleModalClose = () => {
    setShowModal(false);
    // Redirect user or do something after closing modal
    navigate('/'); // example: back to home
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md={8}>
          <h3>Payment Details</h3>
          <h4>Shipping Address</h4>
          <Table bordered striped hover>
            <tbody>
              <tr><td><strong>Full Name</strong></td><td>{formData.firstName} {formData.lastName}</td></tr>
              <tr><td><strong>Street Address</strong></td><td>{formData.streetAddress}{formData.apartment && `, ${formData.apartment}`}</td></tr>
              <tr><td><strong>Town / City</strong></td><td>{formData.town}</td></tr>
              <tr><td><strong>State</strong></td><td>{formData.state}</td></tr>
              <tr><td><strong>Postcode</strong></td><td>{formData.postcode}</td></tr>
              <tr><td><strong>Phone</strong></td><td>{formData.phone}</td></tr>
              <tr><td><strong>Email</strong></td><td>{formData.email}</td></tr>
            </tbody>
          </Table>
        </Col>

        <Col md={4}>
          <h4>Order Summary</h4>
          <Table bordered striped hover>
            <thead>
              <tr>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    <img
                      src={item.img}
                      alt={item.name}
                      style={{ width: 50, height: 50, objectFit: "cover" }}
                    />
                    <span className="ms-3">{item.name}</span>
                  </td>
                  <td>{item.quantity}</td>
                    <td>
                      ₹{((Number(item.price.toString().replace(/[^0-9.-]+/g, '')) || 0) * (Number(item.quantity) || 0)).toFixed(2)}
                    </td>
                  <td>
                    <button
                      onClick={() => handleDeleteFromCart(item._id)}
                      className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
                      title="Remove from Cart"
                    >
                      <i className="bi bi-trash"></i> Remove
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td></td>
                <td><strong>₹{totalCost}</strong></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <Button
            variant="success"
            className="w-100 mt-4"
            onClick={createOrder}
            disabled={loading || !cartItems?.length || !formData?.email}
          >
            {loading ? 'Processing Payment...' : 'Pay Now'}
          </Button>
        </Col>
      </Row>

      {/* Order Details Modal */}
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Order Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Thank you for your order!</p>
          {orderDetails ? (
            <>
              <p><strong>Order ID:</strong> {orderDetails.order_id}</p>
              <p><strong>Status:</strong> {orderDetails.status}</p>
              <p><strong>Total Price:</strong> ₹{orderDetails.total_price}</p>
              <h5>Items:</h5>
              <ul>
                {orderDetails.items.map((item, idx) => (
                  <li key={idx}>
                    <strong>Item Name : {item.name}</strong><br/>
                    ID: {item.item_id} — Quanity: {item.quantity} <br/> Price: ₹{item.price}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p>Loading order details...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>
      <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
                      <Container>
                        <Row className="text-center text-md-start">
                          {/* Left Column */}
                          <Col md={4} className="mb-4 mb-md-0">
                            <img
                              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
                              alt="Mati Haat"
                              style={{ width: "130px", marginBottom: "20px" }}
                            />
                            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
                              <div>
                                <p className="mb-0">Got Questions? Call us 24/7!</p>
                                <strong>+91 9654870373</strong>
                              </div>
                            </div>
                            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
                              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                            </div>
                          </Col>
                
                          {/* Middle Column - Quick Links */}
                          <Col md={4} className="mb-4 mb-md-0">
                            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
                            <ul className="list-unstyled">
                              <ul className="list-unstyled">
                                <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                                <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
                               
                                
                                
                                <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
                              </ul>
                            </ul>
                          </Col>
                
                          {/* Right Column - Customer Care */}
                          <Col md={4}>
                            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
                            <ul className="list-unstyled">
                              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
                              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
                              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
                              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
                              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
                            </ul>
                          </Col>
                        </Row>
                      </Container>
                    </footer>
    </Container>
    
  );
};

export default Payment;
